export default __webpack_public_path__ + "static/media/niseko2.20c9f2dd.webp";